import { mapActions } from "vuex"
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
export const PaperlessMixin = {
  data() {
    return {
      technologyFileBrowseKey:"T"+new Date().valueOf()
    }
  },
  methods: {
    loginForUserName(){
      return new Promise((resolve ,reject)=>{
        if(this.$route.query.username){
          let dataobj = {
            "username": this.$route.query.username,
            "lgsource": "2"
          }
          this.mLogin(dataobj).then(res => {
            if(res.code==200){
              //登陆成功
              this.GetPermissionList().finally((res)=>{
                //强制刷新权限
                this.technologyFileBrowseKey="T"+new Date().valueOf()
              })
              resolve();
            }else{
              this.$message.error(res.message)
              this.Logout({}).then(() => {
                this.$router.push({path: '/user/login', query: { redirect:this.nowPath }})
              }).catch(err => {
                this.$message.error({
                  title: '错误',
                  description: err.message
                })
              })
              reject()
              //单点登录失败
            }
          }).catch((err) => {
            this.$message.error(err.message)
            this.Logout({}).then(() => {
              this.$router.push({path: '/user/login', query: { redirect:this.nowPath }})
            }).catch(err => {
              this.$message.error({
                title: '错误',
                description: err.message
              })
            })
            reject()
            //单点登录失败
          });
        }else{
          let token = Vue.ls.get(ACCESS_TOKEN);
          if(token){
            this.$forceUpdate()
            resolve()
            return
          }
          this.$message.error("登录失败，找不到username")
          this.Logout({}).then(() => {
            this.$router.push({path: '/user/login', query: { redirect:this.nowPath }})
          }).catch(err => {
            this.$message.error({
              title: '错误',
              description: err.message
            })
          })
          reject()
          //单点登录失败
        }
      })
    },
    ...mapActions(["mLogin", "Logout", "PhoneLogin","GetPermissionList"]),
  },
}